<!-- todo would be nice to extend with a reactive provide -->
<template></template>

<script>
export default {
  data: () => ({
    handleScroll: false,
  }),
  mounted() {
    window.addEventListener(
      'scroll',
      (e) => {
        const scrollTop =
          window.pageYOffset ||
          (
            document.documentElement ||
            document.body.parentNode ||
            document.body
          ).scrollTop;

        window.dispatchEvent(
          new CustomEvent('debouncedScroll', {detail: scrollTop}),
        );
      },
      {passive: true},
    );
  },
  destroyed() {
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
};
</script>
